import React, { ReactNode } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

interface MainHeaderProps {
  title: string;
  subtitle: string;
  icon: ReactNode;
  backgroundColor?: string;
  children?: ReactNode;
  color?: string;
}

const MainHeader: React.FC<MainHeaderProps> = ({
  title,
  subtitle,
  icon,
  color = "#ffffff",
  backgroundColor = "#2a5298", // cor linda de roxo para roxo mais claro
  children,
}) => {
  return (
    <Row className="mb-4">
      <Col>
        <Card
          className="border-0 shadow-md"
          style={{
            borderRadius: "16px",
            background: backgroundColor,
          }}
        >
          <Card.Body className="text-white px-4 py-3 d-flex justify-content-between align-items-center">
            <div>
              <h4
                className="fw-semibold mb-1 d-flex align-items-center gap-2"
                style={{ color }}
              >
                {icon}
                {title}
              </h4>

              <small className="text-white-75">{subtitle}</small>
            </div>
            {children && (
              <div className="d-flex align-items-center gap-3">{children}</div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default MainHeader;
